<template>
  <div class="antialiased">
  <Sidebar/>

  <div class="page">
    <Header hint="Cari" :enabled="false" />

    <div class="content">
      <div class="container">

         <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title" v-html="textCase($options.name)"></h2>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0"></div>
                  <div class="col-auto">
                    <button class="btn btn-outline-primary ml-3" @click="_createExcel()" :disabled="loading" v-html="ic('download') + ' Export Excel'"></button>
                    <button class="btn btn-white ml-3" v-html="ic('filter') + ' Filter'" @click="triggerFilter"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="alert alert-info" v-if="this.data.group.length == 0 && !this.filter.requested" v-html="ic('info') + 'Pilih filter untuk memuat' + textCase($options.name).toLowerCase()"/>
          <Skeleton type="table" :length="10"  class="mt-3 bg-white"  v-if="this.loading && this.filter.requested"/>
          <Nodata v-if="!this.loading && this.data.group.length == 0 && this.filter.requested"/>
          <div class="box" v-if="this.data.group.length > 0 && filter.requested && !loading">
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter table-hover card-table table-striped table-control table-no-break">
                  <thead>
                    <th v-for="(row, i) in header" :key="i" v-html="row.replaceAll('_', ' ')"></th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in data.group" :key="i">
                      <td v-html="i+1"></td>
                      <td v-html="row.nama"></td>
                      <td>{{_fetchSale(data,row).dpp | currency}}</td>
                      <td>{{_fetchSale(data,row).qty | currency}}</td>
                      <td>{{_fetchReturn(data,row).dpp | currency}}</td>
                      <td>{{_fetchReturn(data,row).qty | currency}}</td>
                      <td>{{(_fetchReturn(data,row).dpp / _fetchSale(data,row).dpp) * 100  | currency}} %</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FormFilter />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";
import FormFilter from "./modals/filter.vue";

export default {
  name: "MonitoringRetur",
  components: {
    FormFilter,
  },

  data() {
    return {
      header : [
      'No', 
      'Nama', 
      'DPP Penjualan', 
      'Qty Penjualan', 
      'DPP Retur', 
      'Qty Retur',
      'Persetase Retur'
      ]
    };
  },

  mixins: [helper],

  computed: {
    ...mapState(["loading"]),
    ...mapState("monitoring_retur", {
      filter: (state) => state.filter,
      data: (state) => state.data,
    }),
  },
  methods: {
    ...mapActions("monitoring_retur", ["triggerFilter"]),
    _createExcel(){
      let data_excel = []
      this.createExcel({data: data_excel, filename: 'monitoring-retur'})
    },
    _fetchData(data,id){
      return data[id] ? data[id][0] : 0
    },
    _fetchSale(data,row){
      return this._fetchData(data.penjualan,row.id)
    },
    _fetchReturn(data,row){
      return this._fetchData(data.retur_penjualan,row.id)
    }
  },
  watch: {
  },
  created() {
  },

  mounted() {},
};
</script>